{
	"title": "Attempts",
	"grid": {
		"label": "Attempts: {{meet}}",
		"caption": "Attempts, best mark, rank and save state for each athlete",
		"order": "Order",
		"orderHint": "Position in round {{round}}'s jumping order",
		"outOfOrder": "Not in this round's order",
		"competitor": "Athlete",
		"waiting": "Waiting for the athlete",
		"bibColumn": "Bib",
		"stoppedAtCut": "Stopped after round {{round}}: later attempts do not count",
		"notDue": "Not due: this athlete stopped after round {{round}}",
		"attemptLong": "Attempt {{n}}",
		"markAria": "{{name}}, attempt {{n}}",
		"windAria": "{{name}}, attempt {{n}}, wind",
		"windPlaceholder": "wind",
		"metres": "m",
		"markWindHead": "mark (wind)",
		"windAssisted": "Wind-assisted: over +2.0 m/s",
		"best": "Best",
		"countback": "Next best {{mark}}",
		"qm": "QM",
		"qualifyingReached": "Reached the qualifying mark",
		"irm": "Code",
		"irmHint": "Invalid result mark: NM, DNS or DSQ",
		"irmAria": "{{name}}, invalid result mark",
		"noIrm": "None",
		"irmOption": "{{code}} ({{name}})",
		"records": "Records",
		"recordsAria": "{{name}}, records",
		"rank": "Rank",
		"points": "Points",
		"pointsHint": "Combined-event points for the best mark (World Athletics scoring tables)",
		"state": "Save state",
		"empty": "No athletes on the start list yet. Add them in the start list editor."
	},
	"round": {
		"label": "Round",
		"pick": "Round {{n}}",
		"current": "current round",
		"follow": "Back to round {{n}}",
		"orderStart": "Round {{round}} goes in start order.",
		"orderReverse": "Round {{round}} goes in reverse order of the standings after round {{after}}: the leader jumps last.",
		"cut": "The top {{size}} after round {{after}} take the remaining attempts ({{athletes}} athletes started).",
		"cutLabel": "Top {{size}}"
	},
	"view": {
		"label": "Rows",
		"start": "Start order",
		"round": "Jumping order, round {{n}}",
		"result": "Results",
		"resultHint": "Sorted by saved results: rows move only after a save.",
		"wind": "Wind",
		"settings": "Settings"
	},
	"entry": {
		"empty": "Type a mark.",
		"format": "Type a mark like 7.85, X for a foul or - for a pass.",
		"precision": "Marks are measured to the centimetre: two decimals at most.",
		"range": "That mark is too long to be real.",
		"windFormat": "Type the wind like +1.2 or -0.4.",
		"windPrecision": "Wind has one decimal.",
		"windRange": "Wind is between -20.0 and +20.0 m/s.",
		"records": "Records are codes like NR or GR, separated by commas."
	},
	"rowState": {
		"loadingTheirs": "Loading their version…",
		"theirs": "Theirs: {{value}}",
		"theirsEmpty": "Theirs: no result",
		"waitingConnection": "Waiting for the connection",
		"restored": "Kept on this device"
	},
	"refused": {
		"official": "The meet is official. To change results, change the Meet status (you will be asked to confirm).",
		"locked": "The event is locked by the medal desk.",
		"field": "Check {{fields}}.",
		"not_found": "This athlete is no longer in the meet.",
		"forbidden": "Your role cannot enter results.",
		"conflict": "The server refused this row.",
		"unknown": "This row could not be saved. Try again."
	},
	"field": {
		"attempt": "attempt {{n}}",
		"best": "the best mark",
		"irm": "the result code",
		"records": "the records",
		"rank": "the rank",
		"row": "this row"
	},
	"settings": {
		"label": "Meet settings",
		"attemptsAllowed": "Attempts",
		"qualifyingMark": "Qualifying mark",
		"none": "None",
		"edit": "Change settings",
		"save": "Save settings",
		"saved": "Settings saved",
		"lockedHint": "Settings can change only before the first result.",
		"attemptsError": "Attempts must be a whole number from {{min}} to 12.",
		"qmError": "Type the qualifying mark like 7.90, or leave it empty.",
		"stale": "Someone changed this meet first. It has been reloaded: check and save again."
	},
	"heights": {
		"label": "Heights: {{meet}}",
		"card": "Bar heights and each athlete's tries",
		"noHeights": "Add the first bar height above.",
		"cellAria": "{{name}}, {{height}}",
		"outAt": "Out at {{height}}: three failures in a row",
		"jumpOff": "Tied for first after the countback: hold a jump-off, then set the order on the standings.",
		"rules": "Type the tries at each height: O cleared, X failed, - passed (xo, xxo, xxx, x-). Three failures in a row, at one height or across several, end an athlete's competition. Ties are broken by the fewest failures at the last height cleared, then the fewest in all.",
		"entry": {
			"format": "Use O, X and - only: o, xo, xxo, xxx, -, x- or xx-."
		},
		"add": {
			"label": "Bar",
			"button": "Add height",
			"remove": "Remove {{height}}",
			"format": "Type a height like 2.05.",
			"notHigher": "The bar only goes up: type a height above {{height}}."
		}
	},
	"bench": {
		"title": "Field console",
		"none": "No field console has sent a competition yet.",
		"listError": "Could not load the field consoles. Retrying.",
		"apply": "Apply field results",
		"applyNotNow": "Field results can be applied while the meet is at Start list or Live.",
		"phase": {
			"READY": "Ready",
			"RUNNING": "Running",
			"PAUSED": "Paused",
			"FINISHED": "Finished"
		},
		"round": "Round {{n}}",
		"bar": "Bar {{height}}",
		"up": "Up: {{name}}",
		"otherMeet": "The console says it is on another meet. Apply writes nothing here.",
		"otherKind": "The console is on another kind of event. Apply writes nothing here.",
		"noBibs": "No athlete on this start list has a bib, so the console's card cannot be matched. Add bibs to the start list.",
		"startList": {
			"missingBibs_one": "{{count}} athlete has no bib, so the console cannot score them: {{names}}. Add it in the start list's Bib column.",
			"missingBibs_other": "{{count}} athletes have no bib, so the console cannot score them: {{names}}. Add them in the start list's Bib column."
		},
		"unknownBibs": "Bibs on the console with no athlete here: {{bibs}}",
		"card_one": "Console card: {{count}} athlete",
		"card_other": "Console card: {{count}} athletes",
		"differ_one": "{{count}} differs from the grid",
		"differ_other": "{{count}} differ from the grid",
		"col": {
			"bib": "Bib",
			"athlete": "Athlete",
			"card": "Console card"
		},
		"status": {
			"IN": "In",
			"CUT": "Stopped at the cut",
			"OUT": "Out",
			"RETIRED": "Retired",
			"DNS": "Did not start"
		},
		"nothingYet": "nothing yet",
		"new": "new",
		"bib": "Bib {{bib}}: {{problem}}",
		"problem": {
			"RACE_MISMATCH": "The console's card is for another meet or event. Nothing was written.",
			"UNKNOWN_LANE": "no athlete with this bib.",
			"DUPLICATE_LANE": "listed twice on the console.",
			"AMBIGUOUS_LANE": "two athletes share this bib.",
			"EMPTY_SLOT": "the place waits for its athlete.",
			"MANUAL_OVERRIDE": "an operator typed this athlete's result, so the console keeps off it.",
			"SPLITS_UNKEYED": "not applied.",
			"SPLIT_BEYOND_DISTANCE": "not applied.",
			"SPLITS_OUT_OF_ORDER": "not applied.",
			"FINISH_SPLIT_MISMATCH": "not applied.",
			"FINISH_BEFORE_SPLIT": "not applied.",
			"STATUS_WITH_FINISH": "not applied.",
			"IRM_DIFFERS": "the console's status differs from the row's, which was kept.",
			"PLACE_MISMATCH": "the console's place differs from the rank."
		}
	}
}
